<div class="container-fluid">
    <header class="d-flex flex-wrap justify-content-between align-items-center py-2 mb-4">
        <div class="d-flex align-items-center">
            <div *ngIf="currentTitle!='Finish'">
                <button *ngIf="currentTitle && currentTitle!='Home'" (click)="back()" class="btn p-2 bg-light rounded-circle me-2 shadow-none">
                    <i class="material-icons">
                        arrow_back
                    </i>
                </button>
            </div>
            <div *ngIf="currentTitle!='Finish'" class="fs-6">
                <span *ngIf="!currentTitle || currentTitle=='Home'">Hi, <strong>{{userData.name}}</strong></span>
                <span *ngIf="currentTitle && currentTitle!='Home'">{{currentTitle}}</span>
            </div>
        </div>
        <div>
            <div class="pointer d-flex align-items-center justify-content-between rounded-5 bg-light px-2" (click)="showSidenav=true">
                <div><app-avatar [userData]="userData"></app-avatar></div>
                <div class="ps-2">
                    <i class="material-icons">
                        keyboard_arrow_down
                    </i>
                </div>
            </div>
        </div>
    </header>
</div>
<div *ngIf="showSidenav" class="sidenav d-flex justify-content-end align-items-center position-fixed w-100 h-100 start-0 top-0 row m-0 p-0">
    <div class="nav-content col-12 col-md-3 col-lg-3 col-xl-3 h-100 m-0">
        <div class="mb-3">
            <button (click)="showSidenav=false" class="btn close fs-1 p-0 m-0 lh-1 shadow-none">
                &times;
            </button>
        </div>
        <div>
            <div class="mb-4 d-flex align-items-center">
                <div class="me-3">
                    <app-avatar [height]="45" [width]="45" [userData]="userData"></app-avatar>
                </div>
                <div>
                    <div class="fw-bold">{{userData.name}}</div>
                    <small>{{userData.email}}</small>
                </div>
            </div>
            <!-- <div class="mb-3">
                <a class="btn w-100 border border-white">
                    Profile
                </a>
            </div> -->
            <div>
                <button (click)="goLogout()" class="btn btn-danger w-100 border border-white">
                    Logout
                </button>
            </div>
        </div>
    </div>
</div>
